/* eslint-disable arrow-body-style */
import { useState } from 'react';
import moment from 'moment';
import { useRequest } from 'ahooks';
import { queryInitStatClientConfig } from '@/pages/aigc/constants/server';
import http from '@gp/utils/httpTS';
import { FinancialsDataMode } from '../enums';

const TRENDS_BY_MILESTONE_DOWNLOAD_URL = '/api/v1/globalpedia_pc/finance/by_milestone_download';

export const useGetFetchKeyMetricsInfo = <T extends { project_id: string; }>(params: T) => {
  const [loading, setLoading] = useState(true);

  const fetch = () => {
    // @ts-ignore
    return http.get('/api/v1/globalpedia_pc/finance/key_metricsV2', {
      params,
    });
  };

  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'fetchKeyMetricsInfo',
    loadingDelay: 300,
    retryCount: 0,
    onBefore: () => {
      setLoading(true);
    },
    onFinally: () => {
      setLoading(false);
    },
  });

  return { ...data, loading };
};

export const useGetFetchHeadcountTrendDownload = (params?: unknown) => {
  const isByMilestone = params === FinancialsDataMode.ByMilestone;

  const fetch = (mutateParams: any) => {
    return http({
      url: isByMilestone ? TRENDS_BY_MILESTONE_DOWNLOAD_URL : '/api/v1/globalpedia_pc/finance/headcount_trend_download',
      method: 'post',
      data: isByMilestone
        ? {
          type: '2',
          project_id: mutateParams?.project_id,
          studio_id: mutateParams?.studio_id,
          file_type: mutateParams?.file_type,
        }
        : mutateParams,
      original: true,
      responseType: 'blob',
      download: true,
      errorHandler: true,
    });
  };

  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'headcount_trend_download',
    loadingDelay: 300,
    retryCount: 0,
    manual: true,
  });

  return { ...data };
};

export const useGetFetchBudgetTrendingDownload = (
  ...[params]: Parameters<typeof useGetFetchHeadcountTrendDownload>
) => {
  const isByMilestone = params === FinancialsDataMode.ByMilestone;
  const fetch = (mutateParams: any) => {
    return http({
      url: isByMilestone ? TRENDS_BY_MILESTONE_DOWNLOAD_URL : '/api/v1/globalpedia_pc/finance/budget_trend_download',
      method: 'post',
      data: isByMilestone
        ? {
          type: '1',
          project_id: mutateParams?.project_id,
          studio_id: mutateParams?.studio_id,
          file_type: mutateParams?.file_type,
        }
        : mutateParams,
      original: true,
      responseType: 'blob',
      download: true,
      errorHandler: true,
    });
  };

  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'budget_trend_download',
    loadingDelay: 300,
    retryCount: 0,
    manual: true,
  });

  return { ...data };
};

/**
 *
 * @param key 1:全部时间， 2:6个月时间  3:一年时间
 * @returns
 */
const useGetDateRange = (key?: '1' | '2' | '3' | '4' | (string & {})) => {
  // For Last 6 Months
  const sixMonthsAgo = moment().subtract(5, 'months');
  const lastSixStart = moment(sixMonthsAgo).startOf('month').format('YYYY-MM-DD');

  // For Last 12 Months
  const twelveMonthsAgo = moment().subtract(11, 'months');
  const lastTwelveStart = moment(twelveMonthsAgo).startOf('month').format('YYYY-MM-DD');

  const mapKey: Record<string, { start: string; end: string; }> = {
    '1': {
      start: '',
      end: '',
    },
    '2': {
      start: lastSixStart,
      end: moment().endOf('month').format('YYYY-MM-DD'),
    },
    '3': {
      start: lastTwelveStart,
      end: moment().endOf('month').format('YYYY-MM-DD'),
    },
  };
  return mapKey?.[key as any] || mapKey['1'];
};

export default useGetDateRange;
